import React from 'react'
import { useRouteMatch } from 'react-router-dom'

import { Header } from '../Header'
import { Wrapper, Sidebar, Content, DragBar } from './Layout.styles'
import { ComponentsList, GroupsManager } from '../Sidebar'
import { ExportColorTokens } from '../ExportColorTokens'
import { ExportDesignTokensSidebarButton } from '../../../modals/ExportDesignTokensModal'
import { isCwvSpecificRoute } from '@sketch/modules-common'

import { useForDesktop, useDefaultSidebarWidth } from '@sketch/components'
import { useResizableSidePanel } from '@sketch/utils'

import { useGetComponentsGroups } from '../../operations'
import { getGroupType } from '../../utils'
import { useTheme } from 'styled-components'
import { useLocalStorage } from 'react-use'
import { localStorageKeys } from '@sketch/constants'

/**
 * COMPONENT
 */
export const Layout: React.FCC = ({ children }) => {
  const isDesktopAndBigger = useForDesktop()
  const { path } = useRouteMatch()
  const groupType = getGroupType(path)
  const { status, tree } = useGetComponentsGroups(groupType)
  const theme = useTheme()

  const defaultWidth = useDefaultSidebarWidth()
  const [sidebarWidth, setSidebarWidth] = useLocalStorage(
    localStorageKeys.workspaceSidebarWidth,
    defaultWidth
  )

  const { width, resizeHandleRef } = useResizableSidePanel({
    defaultWidth: sidebarWidth ?? defaultWidth,
    minWidth: theme.sidebar.leftWidth,
    maxWidth: theme.sidebar.leftMaxWidth,
    onWidthUpdate: setSidebarWidth,
  })
  const showNewExport = status === 'READY'

  // Note: the sidebar is rendering in a different place for mobile view
  return (
    <Wrapper isDesktopAndBigger={isDesktopAndBigger}>
      {isDesktopAndBigger ? (
        <Sidebar style={{ width }} className="cwvSidebar">
          <DragBar ref={resizeHandleRef} />
          <ComponentsList />
          <GroupsManager isDesktop status={status} tree={tree} />
          {showNewExport ? (
            <ExportDesignTokensSidebarButton />
          ) : (
            showNewExport &&
            isCwvSpecificRoute(path, 'CWV_COLOR_VARIABLES') && (
              <ExportColorTokens />
            )
          )}
        </Sidebar>
      ) : null}
      <Content>
        <Header />
        {children}
      </Content>
    </Wrapper>
  )
}
